import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import PropTypes from 'prop-types';
import PageLoader from '../PageLoader';

const CustomizableModal = ({
  tittle,
  modal,
  setModal,
  icono,
  subTitulo,
  className,
  children,
  width,
  setModalGuardado = null,
  cargandoModal = false
}) => {
  return (
    <Modal
      style={{ maxWidth: width != undefined ? width : '50%' }}
      isOpen={modal}
      toggle={() => {
        setModal(!modal);
        if (setModalGuardado !== null) {
          setModalGuardado(undefined);
        }
      }}
      className={className}
    >
      {cargandoModal && <PageLoader />}
      <ModalHeader toggle={() => {
        setModal(!modal)
        if (setModalGuardado !== null) {
          setModalGuardado(undefined);
        }
      }}>
        <div>
          <i className={icono}></i> {tittle}
        </div>
        {subTitulo != '' && (
          <div>
            <h6>{subTitulo}</h6>
          </div>
        )}
      </ModalHeader>
      <ModalBody>{children}</ModalBody>
    </Modal>
  );
};

CustomizableModal.propTypes = {
  tittle: PropTypes.string,
  modal: PropTypes.bool.isRequired,
  setModal: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.element,
  width: PropTypes.string,
  icono: PropTypes.string,
  subTitulo: PropTypes.string,
  setModalGuardado: PropTypes.func,
  cargandoModal: PropTypes.bool,
};

export default CustomizableModal;
